import React, { useState, useRef, useEffect } from "react";
import Carousel from "react-spring-3d-carousel-2";
import { v4 as uuidv4 } from "uuid";
import { config } from "react-spring";

import { TECHNOLOGIES } from "../../assets/icons-base64";

interface Props {
  buttons: React.ReactNode;
}

export default function Technology(props: Props) {
  const [activeSlideIndex, setActiveSlideIndex] = useState<number>(0);

  const _canvas = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = _canvas.current!;
    const context = canvas.getContext("2d")!;
    context.canvas.width = document.body.clientWidth;
    context.canvas.height = document.body.clientHeight;
    context.lineWidth = 6;
    context.strokeStyle = "#ff4040";

    context.beginPath();
    context.moveTo(context.canvas.width / 2 - context.canvas.width / 4, 0);
    context.lineTo(
      context.canvas.width / 2 - context.canvas.width / 4,
      context.canvas.height / 4
    );
    context.lineTo(
      context.canvas.width / 2 - context.canvas.width / 4,
      context.canvas.height / 4
    );
    context.lineTo(
      context.canvas.width / 4 - context.canvas.width / 4,
      context.canvas.height / 4
    );
    context.lineTo(0, context.canvas.height / 4);
    context.stroke();
    context.closePath();

    context.beginPath();
    context.moveTo(
      context.canvas.width / 2 - context.canvas.width / 4,
      context.canvas.height / 4
    );
    context.lineTo(context.canvas.width / 2, context.canvas.height / 4);
    context.lineTo(
      context.canvas.width / 2,
      context.canvas.height - context.canvas.height / 8
    );
    context.lineTo(
      context.canvas.width / 2 + context.canvas.width / 10,
      context.canvas.height - context.canvas.height / 8
    );
    context.lineTo(
      context.canvas.width / 2 + context.canvas.width / 10,
      context.canvas.height
    );
    context.stroke();
    context.closePath();

    return () => canvas.remove();
  }, [_canvas]);

  const slides = [
    {
      key: uuidv4(),
      content: (
        <div className="lTechnology__card">
          <img
            src={`data:${TECHNOLOGIES.hyperledger.mimeType};base64, ${TECHNOLOGIES.hyperledger.imageData}`}
            alt="posterity"
          />
          <h1>Hyperledger Fabric</h1>
          <p>
            <b>Enterprise-grade permissioned distributed ledger framework</b>{" "}
            for developing solutions and applications. It's modular and
            versatile. It offers a unique approach to consensus that enables
            performance at scale while preserving privacy.
          </p>
        </div>
      ),
    },
    // {
    //   key: uuidv4(),
    //   content: (
    //     <div className='lTechnology__card'>
    //       <img src={`data:${COINS.ETH.mimeType};base64, ${COINS.ETH.imageData}`} alt='posterity' />
    //       <h1>Ethereum ERC-20</h1>
    //       <p>
    //         <b>ERC-20</b> is an official protocol for proposing improvements to the Ethereum (ETH)
    //         network. ERC stands for Ethereum Request for Comment, and 20 is the proposal identifier.
    //         This is a common standard for creating tokens on the Ethereum blockchain.
    //       </p>
    //     </div>
    //   ),
    // },
    {
      key: uuidv4(),
      content: (
        <div className="lTechnology__card">
          <img
            src={`data:${TECHNOLOGIES.kubernetes.mimeType};base64, ${TECHNOLOGIES.kubernetes.imageData}`}
            alt="posterity"
          />
          <h1>Google Kubernetes Engine</h1>
          <p>
            It is an open source container orchestration engine for automating
            deployment, scaling, and management of containerized applications.
            The open source project is hosted by the{" "}
            <b>Cloud Native Computing Foundation (CNCF)</b>.
          </p>
        </div>
      ),
    },
    {
      key: uuidv4(),
      content: (
        <div className="lTechnology__card">
          <h1>Decentralized Finance (DeFi)</h1>
          <p>
            <b>DeFi</b> stands for “Decentralized Finance”, which aims to
            recreate the traditional financial system with less, well,
            middlemen. The vast majority of <b>DeFi</b> platforms are currently
            created on Ethereum.
          </p>
        </div>
      ),
    },
    {
      key: uuidv4(),
      content: (
        <div className="lTechnology__card">
          <img
            src={`data:${TECHNOLOGIES.graphql.mimeType};base64, ${TECHNOLOGIES.graphql.imageData}`}
            alt="posterity"
          />
          <h1>GraphQL Platform</h1>
          <p>
            It's an open-source data query and manipulation language for APIs,
            and a runtime for fulfilling queries with existing data. It was
            developed internally by Facebook in 2012 before being publicly
            released in 2015. The project was moved from Facebook to the GraphQL
            Foundation, hosted by the non-profit Linux Foundation.
          </p>
        </div>
      ),
    },
    {
      key: uuidv4(),
      content: (
        <div className="lTechnology__card">
          <img
            src={`data:${TECHNOLOGIES.nodejs.mimeType};base64, ${TECHNOLOGIES.nodejs.imageData}`}
            alt="posterity"
          />
          <h1>Node.js Cross-Platform</h1>
          <p>
            It's an open-source, cross-platform, JavaScript runtime environment
            that executes JavaScript code outside a web browser. It lets
            developers use JavaScript to write command line tools and for
            server-side scripting—running scripts server-side to produce dynamic
            web page content before the page is sent to the user's web browser.
          </p>
        </div>
      ),
    },
    {
      key: uuidv4(),
      content: (
        <div className="lTechnology__card">
          <img
            src={`data:${TECHNOLOGIES.docker.mimeType};base64, ${TECHNOLOGIES.docker.imageData}`}
            alt="posterity"
          />
          <h1>Docker Platform</h1>
          <p>
            It's an open platform for developing, shipping, and running
            applications. With Docker, you can manage your infrastructure in the
            same ways you manage your applications. You can significantly reduce
            the delay between writing code and running it in production.
          </p>
        </div>
      ),
    },
    {
      key: uuidv4(),
      content: (
        <div className="lTechnology__card">
          <img
            src={`data:${TECHNOLOGIES.react.mimeType};base64, ${TECHNOLOGIES.react.imageData}`}
            alt="posterity"
          />
          <h1>ReactJS</h1>
          <p>
            React is an open-source, front end, JavaScript library for building
            user interface or UI components. It is maintained by Facebook and a
            community of individual developers and companies. React can be used
            as a base in the development of single-page or mobile applications.
          </p>
        </div>
      ),
    },
    {
      key: uuidv4(),
      content: (
        <div className="lTechnology__card">
          <img
            src={`data:${TECHNOLOGIES.binance.mimeType};base64, ${TECHNOLOGIES.binance.imageData}`}
            alt="posterity"
          />
          <h1>BINANCE SMART CHAIN</h1>
          <p>
            Binance Smart Chain was launched in September 2020 and cultivates an
            environment for developing high-performance decentralized
            applications (dapps). ... It's an independent blockchain that could
            run even if Binance Chain went offline. Because BSC is EVM
            compatible, it launched with support for Ethereum tools and dapps.
          </p>
        </div>
      ),
    },
  ].map((slide, index) => {
    return { ...slide, onClick: () => setActiveSlideIndex(index) };
  });

  return (
    <div className="landingWrapper__wrapper lTechnology">
      <canvas ref={_canvas} />
      <div>
        <h1>Technology</h1>
        <Carousel
          slides={slides}
          animationConfig={config.slow}
          showNavigation={true}
          offsetRadius={2}
          goToSlide={activeSlideIndex}
        />
      </div>

      {props.buttons}
    </div>
  );
}
